import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const radius = 24;
const Container = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  float: right;
  position: relative;
  height: 48px;
  margin-right: -15px;
  bottom: 35px;

  ${props => props.theme.isBumpView && `
    bottom: ${props.theme.isMobile ? 110 : 85}px;
  `};

  &.new-nav {
    ${props => props.theme.isBumpView && `
      bottom: ${props.theme.isMobile ? 90 : 85}px;
    `};
  }

  & > svg {
    circle.bg {
      stroke: #ffffff;
      filter: url(#shadow);
      opacity: 0.3;
    }

    circle.progress {
      transform-origin: center;
      transform: rotate(135deg);
      stroke: ${props => props.theme.primaryColor};
      stroke-dasharray: ${Math.PI * 2 * radius};
      stroke-dashoffset: ${props => Math.PI * 2 * radius * (1 - props.percent / 100)};
    }
  }
`;

const Label = styled.span`
  text-transform: capitalize;
  margin-right: 1em;
  color: ${props => props.theme.bodyColor};
  font: ${props => props.theme.fontWeightDccc} 14px/120% ${props => props.theme.fontFamilyBody};
`;

const Value = styled.span`
  color: ${props => (props.isDanger ? props.theme.errorColor : props.theme.bodyColor)};
  font: ${props => props.theme.fontWeightDccc} 13px/130% ${props => props.theme.fontFamilyBody};
  letter-spacing: -0.5px;
  width: 30px;
  margin-left: 1em;
  margin-right: -55px;
  text-align: center;
`;

const ShadowDef = () => (
  <defs>
    <filter id="shadow" x="-30%" y="-30%" width="160%" height="160%" filterUnits="userSpaceOnUse">
      <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
      <feOffset dx="1" dy="3" />
      <feMerge>
        <feMergeNode />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  </defs>
);

export default function Indicator({ percent, newNavEnabled }) {
  const rounded = Math.max(0, Math.round(percent * 100));

  if (rounded >= 100) {
    return null;
  }

  return (
    <Container percent={rounded} className={newNavEnabled ? 'new-nav' : ''}>
      <Label>profile complete</Label>
      <Value isDanger={rounded < 1}>{`${rounded}%`}</Value>
      <svg height="78" width="78">
        <ShadowDef />
        <circle className="bg" r={radius} cx="50%" cy="50%" strokeWidth="6" fill="none" />
        <circle className="progress" r={radius} cx="50%" cy="50%" strokeWidth="6" fill="none" />
      </svg>
    </Container>
  );
}

Indicator.propTypes = {
  percent: PropTypes.number.isRequired,
  newNavEnabled: PropTypes.bool,
};

Indicator.defaultProps = {
  newNavEnabled: false,
};
